const Vue = require('./Vue').default;
const Store = require('./Store').default;
const Calendar = require('./Calendar').default;
const Helpers = require('./Helpers').default;

class App {
  constructor(vue, store, helpers) {
    this.vue = vue;
    this.store = store;
    this.Calendar = Calendar;
    this.helpers = helpers;
  }

  /**
   * I can't change name for this functions because of
   * back end and their foundation core module
   */

  setStores(results) {
    this.store.setResultsStores(results);
  }

  setStoreModules(modules) {
    this.store.setStores(modules);
  }
}

export default new App(new Vue(), new Store(), new Helpers());
